import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../../api/ApiHelpers.ts";
import { setLoaderForUser } from "../../../features/User/redux/slice.ts";
import { logger } from "../../../utils/consoleLogger.ts";

export const getUserData = createAsyncThunk(
  "user/getUserData",
  async (slug: string, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setLoaderForUser(true));
      const res = await get(
        `/company/get_dashboard_user_details/?slug=${slug}`
      );
      return res;
    } catch (error) {
      logger.error("getUserData failed", { slug, error: error?.message, status: error?.name });
      return rejectWithValue({ name: error.name, status: +error?.message });
    }
  }
);

export const getPLGInfo = createAsyncThunk(
  "user/getPLGInfo",
  async (slug: string, { rejectWithValue }) => {
    try {
      const res = await get(`/company/get_plg_info/?slug=${slug}`);
      if (res?.plg_info) return res?.plg_info;
      else return {}
    } catch (error) {
      logger.error("getPLGInfo failed", { slug, error: error?.message, status: error?.name });
      return rejectWithValue({ name: error.name, status: +error?.message });
    }
  }
);
